import { doMutation } from "../../core-module/util/graphqlHelper";

export const submitTrainingForApproval = ({ id }) => {
  const mutation = require("../api/mutation/submitTrainingForApproval.gql");
  const variables = { id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.submitTrainingForApproval };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
